@if (isInitialized) {
  <oe-flat-widget [title]="'GENERAL.SELF_CONSUMPTION' | translate" [icon]="{name: 'oe-consumption', color:'normal'}" button
    [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/selfconsumptionchart'">
    <oe-flat-widget-percentagebar [value]="selfconsumptionValue">
    </oe-flat-widget-percentagebar>
  </oe-flat-widget>
}